<template>
  <div class="plan-summary-card">
    <h2>Plan Summary</h2>
    <BittsContainer class="plan-summary-card__card">
      <PlanSummary @view-billing="() => toggleViewBilling(true)" />
      <ManageSeats />
    </BittsContainer>
    <ViewBillingModal
      v-if="viewBillingModalVisible"
      :visible="viewBillingModalVisible"
      @closed="() => toggleViewBilling(false)"
    />
  </div>
</template>

<script setup lang="ts">
import { BittsContainer } from '@crossbeam/bitts';

import { ref } from 'vue';

import ManageSeats from '@/components/billing/ManageSeats.vue';
import PlanSummary from '@/components/billing/PlanSummary.vue';
import ViewBillingModal from '@/components/billing/ViewBillingModal.vue';

const viewBillingModalVisible = ref(false);

function toggleViewBilling(visible: boolean) {
  viewBillingModalVisible.value = visible;
}
</script>

<style scoped lang="pcss">
.plan-summary-card {
  @apply flex flex-col gap-16 mb-40;
}
.plan-summary-card__card {
  @apply grid grid-cols-2 p-0;
}

section {
  @apply p-24 flex flex-col gap-4 items-start;
  &:last-child {
    @apply border-solid border-l border-neutral-border;
  }
}

h2,
:deep(h2) {
  @apply font-bold text-lg text-neutral-text-strong;
}
:deep(h2) {
  @apply text-m;
}
:deep(h4) {
  @apply text-neutral-text-weak;
}
:deep(p) {
  @apply text-neutral-text-weak;
}
</style>
